// @flow
/* eslint-disable */

import React, { Component } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import styled from 'styled-components'
import type { ReactComponentStyled } from 'styled-components'
import color from 'michelangelo/dist/Components/styles/color'
import Icon from 'michelangelo/dist/Components/Icon'
import Paginator from 'michelangelo/dist/Components/Paginator'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
const Navigation: ReactComponentStyled<{}> = styled.div`
  padding-bottom: 2%;
  display: inline-block;
`
const BottomNavigaton: ReactComponentStyled<{}> = styled.div`
  padding-top: 2%;
`
const Container: ReactComponentStyled<{}> = styled.div`
  text-align: center;
`
const IconContainer: ReactComponentStyled<{}> = styled.div`
  display: inline;
  text-align: 'center';
  padding-left: 20px;
  margin-top: 7px;
  cursor: pointer;
  font-size: '24px';
`
const PDFContainer: ReactComponentStyled<{}> = styled.div`
  padding-left: 25%;
  padding-right: 25%;

  @media only screen and (max-width: 700px) {
    padding-left: 0%;
    padding-right: 0%;
  }
`
type PDFProps = {
  url: string
}
type PDFState = {
    numPages: number,
    pageNumber: number,
    pageRangeDisplayed: number,
    width: number,
    rotate: number,
    resetPosition: boolean
}

class Pdf extends Component<PDFProps, PDFState> {
  navRef: any
  constructor (props: PDFProps) {
    super(props)
    this.state = {
      numPages: 0,
      pageNumber: 1,
      width: this.getDocumentWidth(),
      pageRangeDisplayed: this.getPageRangeDisplayed(),
      rotate: 0,
      resetPosition: false
    }
    this.navRef = React.createRef()
  }

  componentDidMount () {
    this.updateWindowDimensions()
    window.addEventListener('resize', () => this.updateWindowDimensions())
  }

  componentWillUnmount () {
    window.removeEventListener('resize', () => this.updateWindowDimensions())
  }

  onDocumentLoadSuccess (result: any) {
    this.setState({
      numPages: result.numPages,
      pageNumber: 1
    })
  };

  setPage (pageNumber: number) {
    this.setState(state => ({
      pageNumber: pageNumber
    }))
  }

  rotate () {
    this.setState(state => {
      let rotate = state.rotate
      rotate += 90
      if (rotate === 360) {
        rotate = 0
      }
      return { rotate: rotate }
    })
  }

  downloadPDF () {
    window.open(this.props.url, '_blank')
  }

  onLoadError (error: string) {
    return <div>Could not load document, error: {error} </div>
  }

  onItemClick (result: any) {
    this.setState(state => ({ pageNumber: result.pageNumber }))
  }

  updateWindowDimensions () {
    this.setState({
      width: this.getDocumentWidth(),
      pageRangeDisplayed: this.getPageRangeDisplayed()
    })
  }

  onPageLoadSuccess () {
    const { resetPosition } = this.state
    if (resetPosition) {
      window.scrollTo(0, this.navRef.current.offsetTop)
    } else {
      this.setState({ resetPosition: true })
    }
  }

  getWindowWidth () {
    const windowWidth = window.screen.availWidth
    const width = window.innerWidth
    if (width < windowWidth) {
      return width
    }
    return windowWidth
  }

  getDocumentWidth () {
    const width = this.getWindowWidth()
    if (width < 700) {
      return 0.98 * width
    }
    return 0.5 * width
  }

  getPageRangeDisplayed () {
    const width = this.getWindowWidth()
    if (width > 406) {
      return 7
    }
    return 5
  }

  renderLoader () {
    return (
      <IconContainer title='Loading'>
        <Icon color={color.black} iconName='spinner' size='6x' spin />
      </IconContainer>
    )
  }

  renderNavigation () {
    const { numPages, pageNumber, pageRangeDisplayed } = this.state
    let paginator
    let rotate
    if (numPages === 0) {
      paginator = null
      rotate = null
    } else {
      paginator = (
        <Paginator
          previousLabel='PREV'
          nextLabel='NEXT' breakLabel='...'
          pageCount={numPages}
          pageRangeDisplayed={pageRangeDisplayed}
          initialPage={1}
          selected={pageNumber}
          onPageChange={(page) => this.setPage(page)}
          theme={color.info}
        />
      )
      rotate = (
        <IconContainer onClick={() => this.rotate()} title='Rotate'>
          <Icon color={color.info} iconName='redo' size='2x' />
        </IconContainer>
      )
    }
    return (
      <Navigation>
        {paginator}
        {rotate}
        <IconContainer onClick={() => this.downloadPDF()} title='Download'>
          <Icon color={color.info} iconName='download' size='2x' />
        </IconContainer>
      </Navigation>
    )
  }

  render () {
    const { pageNumber, width, rotate } = this.state
    const { url } = this.props
    const loading = this.renderLoader()
    const navigation = this.renderNavigation()
    return (
      <Container ref={this.navRef}>
        {navigation}
        <PDFContainer>
          <Document
            file={url}
            onLoadSuccess={(result) => this.onDocumentLoadSuccess(result)}
            onLoadError={(error) => this.onLoadError(error)}
            onItemClick={(result) => this.onItemClick(result)}
            rotate={rotate}
            loading={loading}
            externalLinkTarget='_blank'
          >
            <Page
              pageNumber={pageNumber}
              width={width}
              loading={loading}
              onLoadSuccess={() => this.onPageLoadSuccess()}
            />
          </Document>
        </PDFContainer>
        <BottomNavigaton>
          {navigation}
        </BottomNavigaton>
      </Container>
    )
  }
}

export default Pdf
